module.exports = __webpack_public_path__ + "static/media/image-card-2.c1f06d5c.png";